import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../config';
import PaymentCards from '../PaymentCards';
import CancelationLink from '../../atoms/CancelationLink';

const PaymentFormHeader = ({
    cancellationUrl,
    paymentMethods,
    title,
    payWithSavedCard,
    setCybersourceVisibility,
    hasSavedCreditCards
}) => (
    <div className="paymentform-header">
        <div className="paymentform-heading">
            <h1 className="paymentform-heading-title">
                {title}
            </h1>
            <PaymentCards items={paymentMethods} />
        </div>
        <div className="paymentform-nav">
            <CancelationLink cancellationUrl={cancellationUrl} />
            {config.features.saveCards.enabled && hasSavedCreditCards && (
                <button
                    type="button"
                    className="paymentform-nav-link-saved-cards"
                    onClick={() => setCybersourceVisibility(false)}
                >
                    {payWithSavedCard}
                </button>
            )}
        </div>
    </div>
);

PaymentFormHeader.propTypes = {
    cancellationUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    paymentMethods: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hasSavedCreditCards: PropTypes.bool.isRequired
};

export default PaymentFormHeader;
